import { useState } from 'react';

import { useAnalytics } from '@src/features/analytics/hooks';
import { AnalyticsEvent } from '@src/features/analytics/types';

export const useReservationLinkingAnalytics = () => {
  const [attempts, setAttemptsCount] = useState(1);
  const increaseAttemptsCount = () => setAttemptsCount((n) => n + 1);

  const { trackEvent } = useAnalytics();

  const trackRequestFailure = (reason: string, properties = {}) => {
    increaseAttemptsCount();
    void trackEvent({
      event: AnalyticsEvent.LinkReservationToProfileRequestFailed,
      properties: {
        ...properties,
        attempts,
        reason,
      },
    });
  };

  const trackRequestSuccess = (properties = {}) =>
    trackEvent({
      event: AnalyticsEvent.LinkReservationToProfileRequested,
      properties: {
        ...properties,
        attempts,
      },
    });

  return {
    trackRequestFailure,
    trackRequestSuccess,
  };
};
